import React from "react";
import { Outlet } from "react-router-dom";
const UserProfileOutlet = () => {
    return (
        <>
        <Outlet/>
        </>
    )

}

export default UserProfileOutlet;